import { Routes, Route } from "@angular/router";
import { BaseRoutingFactory } from "./base-routing.factory";
import { AdminGuard } from "../guards/admin/admin.guard";
import { AuthenticatedGuard } from "../guards/authentication/authenticated.guard";
import { NotAuthenticatedGuard } from "../guards/authentication/not-authenticated.guard";
import { PortalkonfigurationResolver } from "../resolver/portalkonfiguration/portalkonfiguration.resolver";
import { ShellComponent } from "../shell/shell/shell.component";
import { PortalTypGuard } from "../guards/portal-typ.guard";
import { GlobalEnumerationsAcePortaltyp } from "@/api/model-index";
import { UserModelResolver } from "../resolver/user/user-model.resolver";
import { KIChatEnabledGuard } from "../guards/chat/ki-chat-enabled.guard";

export class AppRoutingFactory extends BaseRoutingFactory {
  private readonly coreAppRoute: Routes = [
    {
      path: '',
      component: this.componentService.get(ShellComponent),
      resolve: {
        portalkonfiguration: this.componentService.get(PortalkonfigurationResolver),
        user: this.componentService.get(UserModelResolver)
      },
      canActivate: [
        this.componentService.get(AuthenticatedGuard),
      ],
      children: [
        {
          path: '',
          loadChildren: () => this.componentService.getAsync(import('@/core/features/ausschreibung/ausschreibung.module').then(m => m.AusschreibungModule)),
          canActivate: [this.componentService.get(PortalTypGuard)],
          data: {portaltyp: GlobalEnumerationsAcePortaltyp.Forderung}
        },
        {
          path: 'anfrage',
          loadChildren: () => this.componentService.getAsync(import('@/core/features/anfrage/anfrage.module').then(m => m.AnfrageModule)),
          canActivate: [this.componentService.get(PortalTypGuard)],
          data: {portaltyp: GlobalEnumerationsAcePortaltyp.Forderung}
        },
        {
          path: 'review',
          loadChildren: () => this.componentService.getAsync(import('@/core/features/review/review.module').then(m => m.ReviewModule)),
          canActivate: [this.componentService.get(PortalTypGuard)],
          data: {portaltyp: GlobalEnumerationsAcePortaltyp.Begutachtung}
        },
        {
          path: 'chat',
          loadChildren: () => import('@/core/features/chat/chat.module').then(m => m.ChatModule),
          canActivate: [this.componentService.get(KIChatEnabledGuard)]
        },
        {
          path: 'admin',
          loadChildren: () => this.componentService.getAsync(import('@/core/features/admin/admin.module').then(m => m.AdminModule)),
          canActivate: [
            this.componentService.get(AdminGuard),
          ]
        }
      ]
    },
    {
      path: 'authentication',
      component: this.componentService.get(ShellComponent),
      loadChildren: () => this.componentService.getAsync(import('@/core/components/authentication/authentication.module').then(m => m.AuthenticationModule)),
      canActivate: [this.componentService.get(NotAuthenticatedGuard)],
      resolve: {
        portalkonfiguration: this.componentService.get(PortalkonfigurationResolver),
      }
    },
    { path: '**', redirectTo: '' }, //if queried route is not found navigate to root
  ];

  public create(): Routes {
    const coreRoute = this.coreRoute;

    return coreRoute;
  }

  protected get coreRoute(): Routes {
    return this.coreAppRoute;
  }

  protected registerChild(coreRoute: Routes, route: Route): void {
    const formRoutes = coreRoute![0].children!;
    const foundIndex = formRoutes?.findIndex(formRoute => formRoute.path === route.path);
    if (foundIndex >= 0) {
      formRoutes[foundIndex] = route;
    }
    else {
      coreRoute![0].children!.push(route);
    }
  } 
}